// The data/time we want to countdown to
const countDownDate = new Date(`${countdownDate} ${countdownTime}:00`).getTime();

// Run myfunc every second
const myfunc = setInterval(function () {
  const now = new Date().getTime();
  const timeleft = countDownDate - now;
  const barElem = document.querySelector('.countdown-bar');
  const barToday = document.querySelector('.bar-today');
  const barTomorrow = document.querySelector('.bar-tomorrow');

  if (timeleft < 0) {
    clearInterval(myfunc);
    barElem.style.display = 'none';
    barToday.style.display = 'none';
    barTomorrow.style.display = 'none';
    barElem.classList.add('expired');

    return;
  }

  // Calculating the days, hours, minutes and seconds left
  const days = Math.floor(timeleft / (1000 * 60 * 60 * 24));
  const hours = Math.floor((timeleft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  const minutes = Math.floor((timeleft % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((timeleft % (1000 * 60)) / 1000);
  const zeroHours = hours < 10 ? ` 0${hours}` : hours;
  const zeroMinutes = minutes < 10 ? ` 0${minutes}` : minutes;
  const zeroSeconds = seconds < 10 ? ` 0${seconds}` : seconds;

  const daySingular = '<span class="small-hide">day</span><span class="medium-hide large-up-hide">d</span>';
  const dayPlural = '<span class="small-hide">days</span><span class="medium-hide large-up-hide">d</span>';

  const hourSingular = '<span class="small-hide">hour</span><span class="medium-hide large-up-hide">h</span>';
  const hourPlural = '<span class="small-hide">hours</span><span class="medium-hide large-up-hide">h</span>';

  const minutesSingular = '<span class="small-hide">minute</span><span class="medium-hide large-up-hide">m</span>';
  const minutesPlural = '<span class="small-hide">minutes</span><span class="medium-hide large-up-hide">m</span>';

  let daysLeft = `${days} ${dayPlural}`;

  if (days < 1) {
    barToday.style.display = 'block';
    barTomorrow.style.display = 'none';
  } else {
    barToday.style.display = 'none';
    barTomorrow.style.display = 'block';
    daysLeft = days == 1 ? `${days} ${daySingular}` : `${days} ${dayPlural}`;
  }

  // Result is output to the specific element
  document.getElementById('bar-today--hours').textContent = `${zeroHours} :`;
  document.getElementById('bar-today--mins').textContent = ` ${zeroMinutes} :`;
  document.getElementById('bar-today--secs').textContent = zeroSeconds;
  document.getElementById('bar-tom--days').innerHTML = daysLeft;
  document.getElementById('bar-tom--hours').innerHTML =
    hours == 1 ? `${zeroHours} ${hourSingular}` : `${zeroHours} ${hourPlural}`;
  document.getElementById('bar-tom--mins').innerHTML =
    minutes == 1 ? `${zeroMinutes} ${minutesSingular}` : `${zeroMinutes} ${minutesPlural}`;

  // Display the message when countdown is over
  if (timeleft < 0) {
    clearInterval(myfunc);
    document.getElementById('bar-today--hours').textContent = '0 :';
    document.getElementById('bar-today--mins').textContent = '0 :';
    document.getElementById('bar-today--secs').textContent = '0 :';
    document.getElementById('bar-tom--days').innerHTML = `0 ${dayPlural}`;
    document.getElementById('bar-tom--hours').innerHTML = `0 ${hourPlural}`;
    document.getElementById('bar-tom--mins').innerHTML = `0 ${minutesPlural}`;
    barElem.style.display = 'none';
    barToday.style.display = 'none';
    barTomorrow.style.display = 'none';
  }

  barElem.style.display = 'block';
}, 1000);
